export default __webpack_public_path__ + "static/media/fingertips-img.f2788731.svg";